import { color } from "@smartsheet/design-tokens-react";
import { AlertErrorAltIcon, AlertWarningIcon, InfoIcon, CheckIcon } from "@smartsheet/lodestar-icons";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { CheckInCircleIcon, ExclamationAlertErrorIcon, InfoIcon as InfoIconUrsa } from "@smartsheet/ursa-icons";
import React from "react";
import { Spinner } from "../../spinner";
import { FormLabelValidationState } from "../types";

const icons = {
    error: {
        "lodestar-light": <AlertErrorAltIcon size="small" role="img" color={color("color--icons--error--weak")} />,
        "ursa-light": <ExclamationAlertErrorIcon size={16} color={color("color--icons--error--default")} />,
    },
    warn: {
        "lodestar-light": <AlertWarningIcon size="small" role="img" color={color("color--icons--warning--weak")} />,
        "ursa-light": <ExclamationAlertErrorIcon size={16} color={color("color--icons--warning--default")} />,
    },
    info: {
        "lodestar-light": <InfoIcon size="small" role="img" />,
        "ursa-light": <InfoIconUrsa size={16} color={color("color--text--neutral--weak")} />,
    },
    success: {
        "lodestar-light": <CheckIcon size="small" role="img" color={color("color--icons--success--weak")} />,
        "ursa-light": <CheckInCircleIcon size={16} color={color("color--icons--success--default")} />,
    },
};

export const iconBasedOnValidationState = (validationState: FormLabelValidationState, themeMode: RequiredThemeKeys) => {
    if (validationState === "waiting") return <Spinner />;

    switch (themeMode) {
        // Lodestar and oldestar use the same Lodestar icon on purpose here. Oldestar never had a
        // FormLabel component so it was alright to use the new icons.
        case "oldestar":
        case "lodestar-light":
            return icons[validationState]["lodestar-light"];

        case "ursa-light":
        case "ursa-dark":
            return icons[validationState]["ursa-light"];
    }
};
